"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _antd = require("antd");

var _icons = require("@ant-design/icons");

var _store = require("../store");

var _actions = require("../actions");

var _templateObject, _templateObject2;

var DeploymentBadge = function DeploymentBadge(props) {
  var _authUser$capabilitie;

  var _props$deployment = props.deployment,
      badgeImage = _props$deployment.badgeImage,
      badgeLink = _props$deployment.badgeLink,
      buildHook = _props$deployment.buildHook,
      lastBuild = _props$deployment.lastBuild;

  var _ref = (0, _store.useStore)(),
      _ref2 = _slicedToArray(_ref, 2),
      _ref2$ = _ref2[0],
      config = _ref2$.config,
      authUser = _ref2$.authState.authUser,
      _ref2$$cmsState = _ref2$.cmsState,
      siteID = _ref2$$cmsState.siteID,
      sites = _ref2$$cmsState.sites,
      deploymentImage = _ref2$$cmsState.deploymentImage,
      dispatch = _ref2[1];

  (0, _react.useEffect)(function () {
    var interval = null;

    if (badgeImage) {
      interval = setInterval(function () {
        // We use a central deployment badge image instead of the one in the site object to avoid a flickering
        // when deploy is triggered and user navigates between pages
        dispatch({
          type: 'SET_DEPLOYMENT_IMAGE',
          payload: "".concat(badgeImage, "?v=").concat(Math.floor(Math.random() * Math.floor(100)))
        });
      }, 10000);
    }

    return function () {
      return clearInterval(interval);
    };
  }, []);

  var handleDeploy = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _actions.siteActions.deploySite({
                id: siteID
              }, dispatch, config);

            case 2:
              if (badgeImage) {
                dispatch({
                  type: 'SET_DEPLOYMENT_IMAGE',
                  payload: "".concat(badgeImage, "?v=").concat(Math.floor(Math.random() * Math.floor(100)))
                });
              }

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleDeploy() {
      return _ref3.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/_react.default.createElement(_antd.Space, {
    size: 20
  }, (deploymentImage || badgeImage) && lastBuild && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, badgeLink && authUser !== null && authUser !== void 0 && (_authUser$capabilitie = authUser.capabilities) !== null && _authUser$capabilitie !== void 0 && _authUser$capabilitie.manage_options ? /*#__PURE__*/_react.default.createElement(_antd.Tooltip, {
    title: "Open Deploy",
    placement: "bottom"
  }, /*#__PURE__*/_react.default.createElement(DeploymentLink, {
    href: badgeLink,
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/_react.default.createElement(DeploymentStatus, {
    src: deploymentImage || badgeImage
  }))) : /*#__PURE__*/_react.default.createElement(DeploymentStatus, {
    src: deploymentImage || badgeImage
  })), buildHook && /*#__PURE__*/_react.default.createElement(_antd.Tooltip, {
    title: "Deploy Website",
    placement: "bottom"
  }, /*#__PURE__*/_react.default.createElement(_antd.Button, {
    icon: /*#__PURE__*/_react.default.createElement(_icons.DeploymentUnitOutlined, null),
    onClick: handleDeploy
  })));
};

var DeploymentLink = _styledComponents.default.a(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  height: 32px;\n  display: flex;\n  align-items: center;\n"])));

var DeploymentStatus = _styledComponents.default.img(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  height: 16px;\n  margin: 0 10px;\n"])));

var _default = DeploymentBadge;
exports.default = _default;